module.exports = __webpack_public_path__ + "img/gen_background.6d1bf3a0.jpg";